import { Link } from '@tanstack/react-router';

export interface BreadcrumbProps {
  readonly machineId: string;
}

export function Breadcrumb({ machineId }: BreadcrumbProps): JSX.Element {
  return (
    <nav className="text-xs font-mono text-text-dim mb-3" aria-label="Breadcrumb">
      <Link to="/dashboard" className="hover:text-text">
        Dashboard
      </Link>
      <span className="mx-2 text-muted">›</span>
      <span className="text-text">{machineId}</span>
    </nav>
  );
}
